import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import {
  BulkUpdateLotOffersResponseInterface,
  fetchBulkStatusLotOffers,
  fetchBulkStatusLotOffersInterface,
} from "./fetchBulkStatus";

export interface BulkEditStatusResponseInterface {
  headers: any;
  data: BulkUpdateLotOffersResponseInterface;
  status: number;
}

export const bulkEditStatus = createAsyncThunk(
  "lotList/fetchBulkStatus",
  async (
    args: fetchBulkStatusLotOffersInterface,
    { getState }
  ): Promise<BulkEditStatusResponseInterface> => {
    const { user } = getState() as RootState;
    const response = await fetchBulkStatusLotOffers({
      ...args,
      endpoint: user.role,
    });
    return {
      headers: response.headers,
      data: response.data,
      status: response.status,
    };
  }
);
